function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#47dfed;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 48.635) rotate(-90)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M24.317,0A24.317,24.317,0,1,0,48.635,24.317,24.3,24.3,0,0,0,24.317,0Zm0,45.393A21.075,21.075,0,1,1,45.393,24.317,21.1,21.1,0,0,1,24.317,45.393Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M27.3,12.71H16.471V1.881a1.881,1.881,0,1,0-3.761,0V12.71H1.881a1.881,1.881,0,0,0,0,3.761H12.71V27.3a1.881,1.881,0,1,0,3.761,0V16.471H27.3a1.881,1.881,0,0,0,0-3.761Z",
  transform: "translate(24.317 3.488) rotate(45)"
}));

var SvgCancelado = function SvgCancelado(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.635,
    height: 48.635,
    viewBox: "0 0 48.635 48.635",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCancelado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancelado.38c2fbc1.svg";
export { ForwardRef as ReactComponent };